"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurnNFTForm = void 0;
const default_contract_action_1 = require("@components/default-contract-action");
const token_hooks_1 = require("@hooks/contracts/token.hooks");
const form_hooks_1 = require("@hooks/form.hooks");
const translation_hooks_1 = require("@hooks/translation.hooks");
const text_input_1 = require("@shared-modules/components/text-input");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const react_1 = __importStar(require("react"));
const helper_1 = require("./helper");
require("./styles.scss");
const BurnNFTForm = (props) => {
    const { token, onClose } = props;
    const translator = (0, translation_hooks_1.useComponentTranslation)("burnNFTForm");
    const commonTranslator = (0, translation_hooks_1.useCommonTranslation)();
    const burnToken = (0, token_hooks_1.useTokenBurning)(token.tokenId, token.contractAddress);
    const code = (0, react_1.useMemo)(() => bignumber_js_1.default.random()
        .times(999999 - 100000)
        .plus(100000)
        .toFixed(0), []);
    const { form, fieldHandlers, submit, validationResults } = (0, form_hooks_1.useForm)({
        initialData: helper_1.DEFAULT_FROM,
        validators: (0, helper_1.getValidators)(code, commonTranslator),
        submit: (_, { isValid }) => __awaiter(void 0, void 0, void 0, function* () {
            if (isValid) {
                const { blockNumber } = yield burnToken();
                onClose(blockNumber);
            }
        }),
    });
    return (react_1.default.createElement("div", { className: "c-burn-nft-form" },
        react_1.default.createElement("div", { className: "c-burn-nft-form__header" }, translator("title")),
        react_1.default.createElement("div", { className: "c-burn-nft-form__attention" }, translator("alert")),
        react_1.default.createElement("div", { className: "c-burn-nft-form__description" }, translator("description")),
        react_1.default.createElement("div", { className: "c-burn-nft-form__security-code" },
            react_1.default.createElement("div", { className: "c-burn-nft-form__security-code-label" }, translator("securityCodeHelpLabel")),
            react_1.default.createElement("div", { className: "c-burn-nft-form__security-code-value" }, code)),
        react_1.default.createElement("div", { className: "c-burn-nft-form__field" },
            react_1.default.createElement(text_input_1.TextInput, { label: translator("securityCodeLabel"), handleChange: fieldHandlers.code, error: validationResults.results.code, value: form.code, placeholder: translator("securityCodePlaceholder") })),
        react_1.default.createElement("div", { className: "c-burn-nft-form__button" },
            react_1.default.createElement(default_contract_action_1.DefaultContractAction, { actionName: translator("burnButton"), actionHandler: submit }))));
};
exports.BurnNFTForm = BurnNFTForm;
